module.exports = __webpack_public_path__ + "img/DiHS_Dashboard_Icon_Kontakt.0a136792.svg";